<template>
  <v-app>
    <v-content>
      <table class="wrapper-table">
        <tr class="content-tr">
          <td>
            <router-view />
          </td>
        </tr>
        <tr>
          <td>
            <Footer/>
          </td>
        </tr>
      </table>
    </v-content>
  </v-app>
</template>

<script>
import Footer from "../src/components/activity/Footer";
export default {
  name: "App",
  components: { Footer },
};
</script>

<style scoped>
@import "./assets/styles/ezcred.css";
.wrapper-table{
    width: 100%;
    height: 100%;
    margin-top: -1.6px;
}
.content-tr{
    vertical-align: baseline;
    height: 95%;
}
</style>
